import { css } from '@emotion/core'
import { Theme } from '@themes/theme'

export const OneFoldClubList = (theme: Theme) => css`
  &.one-fold-club-list {
    border: none;
    .ant-list-header {
      padding: 16px 0 10px;
      border-bottom: none;
      background: ${theme.color.modalBg};
      border-radius: 18px 18px 0 0;
      & div {
        color: ${theme.color.modalTxt};
        font-size: ${theme.font.title};
      }
    }
    .ant-list-items {
      height: 167px;
      padding: 6px 6px 0;
      overflow-x: hidden;
      overflow-y: scroll;
      background-color: ${theme.color.modalDarkBg};
    }
    .ant-list-item {
      justify-content: space-between;
      padding: 0 9px;
      text-align: left;
    }
  }
  
`